import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import { cn } from '../../utils';
import './Content.css';

class Content extends Component {
  render() {
    return (
      <div className={cn('content', this.props.className)}>
        {
          // If loading show [CircularProgress] indicator
          this.props.loading ?
            <div className={this.props.loadingClass}>
              <CircularProgress size={70} />
            </div> :
            // If error show error message indicator and ask to retry
            this.props.error ?
              <div className={this.props.errorClass}>
                <Typography component={'span'} variant="h6">Tunnistamaton virhe</Typography>
                {
                  this.props.onRetry &&
                  <Button
                    className="margin-md-vert"
                    color="primary"
                    onClick={this.props.onRetry}
                  >Yritä uudelleen</Button>
                }
              </div> :
              // If empty props show empty [span]
              this.props.empty ?
                <span></span> :
                // Else show children. The list of companies when used in drawer menu
                <div className={cn('content-body', this.props.scroll && 'content-scrolls')}>
                  {this.props.children}
                </div>
        }
      </div>
    );
  }
}

export default Content;
